// Cartões autorais da coluna direita do bloco Palavra do Dia (Home).
// WordThatRemainsCard: frase_compartilhar sobre fundo dourado sóbrio,
// rodapé apenas com a referência bíblica central. Silêncio elegante se vazio.
// JourneyMilestoneCard: cycle_day em destaque com data por extenso e selo
// litúrgico quando ativo. Integra o que já existe, sem duplicar informação.
import React from "react";
import { Quote } from "lucide-react";
import { LiturgicalBadge } from "./LiturgicalBadge";

export const WordThatRemainsCard = ({ phrase, verseRef }) => {
  if (!phrase || !String(phrase).trim()) return null;
  return (
    <div
      data-testid="home-word-card"
      className="relative overflow-hidden rounded-2xl bg-gold p-6"
    >
      <Quote className="absolute top-5 right-5 w-8 h-8 text-navy/15" aria-hidden="true" />
      <p className="text-[10px] uppercase tracking-[0.3em] text-navy/60">
        Palavra que Permanece
      </p>
      <p
        className="mt-3 font-display text-xl leading-snug text-navy pr-6"
        data-testid="home-word-card-phrase"
      >
        {phrase}
      </p>
      {verseRef ? (
        <p
          className="mt-5 pt-4 border-t border-navy/15 text-[11px] uppercase tracking-widest text-navy/70"
          data-testid="home-word-card-ref"
        >
          {verseRef}
        </p>
      ) : null}
    </div>
  );
};

export const JourneyMilestoneCard = ({ cycleDay, dateIso, weeklyTheme }) => {
  const n = Number(cycleDay);
  const hasDay = Number.isFinite(n) && n >= 1 && n <= 365;
  const d = dateIso ? new Date(`${dateIso}T12:00:00`) : new Date();
  const dateLong = d.toLocaleDateString("pt-BR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  if (!hasDay && !dateIso) return null;
  return (
    <div
      data-testid="home-journey-card"
      className="rounded-2xl border border-navy/15 bg-[hsl(var(--parchment))] p-6"
    >
      <p className="text-[10px] uppercase tracking-[0.3em] text-navy/55">
        Marco da Jornada
      </p>
      {hasDay && (
        <p
          className="mt-3 font-display text-navy leading-none"
          data-testid="home-journey-card-day"
        >
          <span className="text-5xl">Dia {n}</span>
          <span className="ml-2 text-lg text-navy/60">de 365</span>
        </p>
      )}
      <p className="mt-2 text-sm text-navy/60" data-testid="home-journey-card-date">
        {dateLong}
      </p>
      <LiturgicalBadge
        weeklyTheme={weeklyTheme}
        testid="home-liturgical-badge"
        className="mt-4"
      />
    </div>
  );
};
